import { Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

const StyledText = styled(Typography)`
  // increase specificity
  && {
    display: block;
    padding-right: 15px;
  }
`

export const ItemWarning: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <StyledText variant="caption" paragraph>
    {children}
  </StyledText>
)
